<template>
  <Dialog
    @update:open="emit('update:open', $event)"
    :showFooter="false"
    variant="default"
    side="bottom"
  >
    <template #header>
      <DrawerHeader
        :title="t('components.views.title')"
        v-bind="{
          variant: 'tertiary',
          type: 'gray',
          size: 'xl',
        }"
        class="bg-primary max-md:rounded-none border-b border-secondary"
      />
    </template>
    <template #content>
      <div class="overflow-y-auto bg-primary p-4">
        <ViewSelector
          :views="views"
          :type="type"
          :currentView="currentView"
          :allowViewCreation="false"
          @selectView="handleSelectView($event)"
          @deleteView="handleDeleteView($event)"
          @addView="handleAddView($event)"
          @renameView="handleRenameView($event)"
        />
      </div>
    </template>
  </Dialog>
</template>

<script setup>
import { Dialog } from "@/SharedComponents/Dialog";
import { DrawerHeader } from "@/SharedComponents/Drawer";
import { ViewSelector } from "@/SharedComponents/PageHeader/Partials";
import { useI18n } from "vue-i18n";

const emit = defineEmits(["selectView", "deleteView", "addView", "renameView"]);

defineProps({
  type: {
    type: String,
    required: true,
  },
  views: {
    type: Array,
    required: true,
  },
  currentView: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();

const handleSelectView = (view) => {
  emit("selectView", view);
};

const handleDeleteView = () => {};

const handleAddView = (view) => {
  emit("addView", view);
};

const handleRenameView = (view) => {
  emit("renameView", view);
};
</script>
